import { Component, ViewChild } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  AlertController,
  NavParams,
  SelectPopover,
} from "ionic-angular";
import { ModalsEngineselectorPage} from "../modals-engineselector/modals-engineselector";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { RestProvider } from "../../providers/rest/rest";
import { DataProvider } from "../../providers/data/data";
import { ViewerPage } from "../viewer/viewer";
import * as fs from 'fs';
import * as Axios from "axios";
import { FileWriter } from "@ionic-native/file";
import { ModalsEngineselectorPageModule } from "../modals-engineselector/modals-engineselector.module";
import { FORGECLIENT } from '../../environments/environment';


@IonicPage()
@Component({
  selector: "page-bundle",
  templateUrl: "bundle.html",
})
export class BundlePage {
  @ViewChild("fileInput") fileInput;
  bundleForm = new FormGroup({
    bundleControl: new FormControl(),
  });
  reader = new FileReader();
  fileContent;
  fileToUpload: File = null;
  error;
  checkFile = false;
  engineList = [];
  bundleList = [];
  loading;
  nickname = FORGECLIENT.CLIENT_ID;
  appboundle_name = 'UpdateRVTParam';
  zip_name = 'UpdateRVTParam.zip';
  alias = '23';
  findApp = false;
  page = 1;



  activeengine: number;
  status: boolean = false;
  enginename = localStorage.getItem('engine') == null ? 'Autodesk.Revit+2020' : localStorage.getItem('engine');

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public modalController: ModalController,
    public AlertController: AlertController,
    private rest: RestProvider
  ) {}

  ionViewDidLoad() {
    this.presentLoadingWithOptions();
    this.rest.dumpEngines().subscribe(engines => {
      console.log(engines);
      engines.data.forEach(element => {
        if(element.split('.')[1].substring(0,5) == 'Revit') {
          console.log(element);
          this.engineList.push(element);
        }
      });
      this.createAppBundle();
      this.stopLoading();
    });
    $("#uploadButton").on("click", function(){
      $("#files").val('');
   })​
  }

  engineSelect(engine, id) {
    $('.activeli').removeClass('activeli');
    $('#' + id).addClass('activeli');
    this.status = !this.status;
    this.enginename = engine;
    localStorage.setItem('engine', this.enginename);
    let engineSplit = engine.split('.');
    console.log(engineSplit);
    console.log("##########  GET DEFINED APP BUNDLES  ##########");
    this.bundleList = [];
    this.createAppBundle();
  }

  bundleSelect (bundle) {
    console.log(bundle);
  }

  createAppBundle() {
    this.rest.getDefinedAppbundles(this.page).subscribe( bundles => {
      bundles.data.forEach(element => {
        if(this.nickname + '.' + this.appboundle_name == element.split('+')[0])
        this.bundleList.push(element);
      });
      if(bundles.paginationToken !== null) {
        this.page++ ;
        this.createAppBundle();
      } else {
        console.log(0);
      }
      if(this.bundleList.length === 0) {
        $('#uploadButton').removeClass('disabled');
      } else {
        $('#uploadButton').addClass('disabled');
      }
    });
  }

  deleteAppbundle(id) {
    this.rest.deleteAppBundle(id.split('.')[1].split('+')[0]).subscribe( response => {
      this.bundleList = [];
      this.page = 1;
      this.createAppBundle();
    })
  }

  handleFileInput(files: FileList) {
    if(files.length > 0) {
      this.reader.readAsArrayBuffer(files.item(0));
      this.reader.onload = (res) => {
        let blob = new Blob([new Uint8Array(this.reader.result as ArrayBuffer)]);
        this.fileContent = blob;
        this.fileToUpload = files.item(0);
        if(this.fileToUpload.name.split('.')[0] == this.appboundle_name) {
          this.checkFile = true;
        } else {
          this.presentAlertBundleError();
        }
      };
    }
  }

  async onSubmit() {
    this.checkFile = false;
    this.presentLoadingWithOptions();
    let qualifiedAppBundleId = this.nickname + '.' + this.appboundle_name + '+' + this.alias;
    this.bundleList.forEach(element => {
      if(qualifiedAppBundleId == element) {
        this.findApp = true;
      }
    });
    if(this.findApp) {
      console.log("findAPP TRUE");
      this.rest.createAppBundleVersion(this.enginename, this.appboundle_name).subscribe(cbund => {
        console.log("create Version of bundle => ",cbund);
        localStorage.setItem('bundle', JSON.stringify(cbund));
        this.rest.uploadZip(this.appboundle_name,this.zip_name,cbund['uploadParameters']['formData'], this.fileToUpload, this.fileContent).subscribe(zip => {
          this.rest.updateAppBundleAlias(this.appboundle_name,this.alias,cbund['version']).subscribe(aliass => {
            this.rest.dumpEngines().subscribe(engines => {
              engines.data.forEach(element => {
                if(element.split('.')[1].substring(0,5) == 'Revit') {
                  this.engineList.push(element);
                }
              });
              this.createAppBundle();
            });
            this.stopLoading();
          });
        }, err => {
          this.stopLoading();
        });
      }, errBundle => {
        this.stopLoading();
        this.presentAlertEngineError();
      });
    } else {
      console.log("findAPP FALSE");
      this.rest.createAppBundle(this.enginename, this.appboundle_name).subscribe(cbund => {
        console.log("create BUNDLE => " ,cbund);
        localStorage.setItem('bundle', JSON.stringify(cbund));
        this.rest.uploadZip(this.appboundle_name,this.zip_name,cbund['uploadParameters']['formData'], this.fileToUpload, this.fileContent).subscribe(zip => {
          this.rest.createAppBundleAlias(this.appboundle_name, this.alias, 1).subscribe(aliass => {
            this.rest.dumpEngines().subscribe(engines => {
              engines.data.forEach(element => {
                if(element.split('.')[1].substring(0,5) == 'Revit') {
                  this.engineList.push(element);
                }
              });
              this.createAppBundle();
            });
            this.stopLoading();
          });          
        }, err => {
          this.stopLoading();
        });
      }, errBundle => {
        this.stopLoading();
        this.presentAlertEngineError();
      });
    }   
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      spinner: null,
      content: 'お待ちください...',
      cssClass: 'custom-class custom-loading'
    });
    console.log('loader ---->>>>');
    return await this.loading.present();
  }
  
  async stopLoading() {
    console.log('loader <<<<----');
    return await this.loading.dismiss();
  }
  async presentAlertConfirm(bundle) {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: '警告!',
      message: '<p><strong>バケット</strong>を削除してもよろしいですか</p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('cancelled');
          }
        }, {
          text: 'はい',
          handler: () => {
            this.deleteAppbundle(bundle);
          }
        }
      ]
    });

    await alert.present();
  }

  async presentAlertEngineError() {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: 'エラー!',
      message: '<p><strong>エンジン</strong>を選択</p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }
      ]
    });

    await alert.present();
  }

  async presentAlertBundleError() {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: 'エラー!',
      message: '<p>間違った<strong>バンドル</strong></p>',
      buttons: [
        {
          text: 'キャンセル',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }
      ]
    });

    await alert.present();
  }

  async presentAlertEngine() {
    let request_sent = this.modalController.create(
      ModalsEngineselectorPage,
      {},
      {
        showBackdrop: true,
        enableBackdropDismiss: true,
      }
    );

    request_sent.present().catch(err => {

    });
    
    /*const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      title: '警告!',
      message: '<p>Please choose your <strong>Autodesk Revit </strong> engine</p>',
      // buttons: eval("[(" + content +")]")
        // {text: 'キャンセル',role: 'cancel',cssClass: 'secondary',handler: (blah) => {console.log('xaxaxa');}},
        // {text: 'キャンセル',role: 'cancel',cssClass: 'secondary',handler: (blah) => {console.log('xaxaxa');}},
        // {text: 'キャンセル',role: 'cancel',cssClass: 'secondary',handler: (blah) => {console.log('xaxaxa');}},
        // {text: 'キャンセル',role: 'cancel',cssClass: 'secondary',handler: (blah) => {console.log('xaxaxa');}},
      
    });
    for(let i = 0; i < this.engineList.length; i++){
      let content = {text: this.engineList[i].split('+')[1],cssClass: 'secondary',handler: (blah) => {console.log('xaxaxa" + this.engineList[i] + "');}};
      alert.data.buttons.push(content);
    }
    console.log(this.engineList);
    console.log(alert);

    await alert.present();*/
  }
}



// WEBPACK FOOTER //
// ./src/pages/bundle/bundle.ts